import { PageConfig } from "@shared/components/page-config";
import { FC, lazy, Suspense } from "react";
import HowToLearnDetail from "./components/HowToLearnDetail";
import useDetailPageConfig from "./hooks/useDetailPageConfig";
import NotFound from "pages/404";
const HowToLearnAdmin = lazy(
  () => import("../../features/how-to-learn/components/howtoLearnAdmin")
);

const HowToLearnSlugPage: FC = () => {
  const { pageConfig, error, mutate, isAdmin, landing, landingDetail } =
    useDetailPageConfig();

  if (error?.error?.code === 404) return <NotFound />;
  return (
    <PageConfig config={pageConfig}>
      {isAdmin ? (
        <Suspense fallback={null}>
          <HowToLearnAdmin mutate={mutate} id={landingDetail?.data.id} />
        </Suspense>
      ) : null}

      <HowToLearnDetail />
    </PageConfig>
  );
};

export default HowToLearnSlugPage;
